'use strict';

/* Controllers */

angular.module('FlexyBeautyApp.controllers')
    .controller('ManagerModeCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "UserSrv", "$window",
        function ($scope, $rootScope, dialog, dialogsModel, UserSrv, $window) {
            $scope.ad = dialogsModel.ad;
            $scope.dd = {
                alerts: [],
                mode: "quit", // quit / login / register
                processing: false,
                user: {
                    password: "",
                    passwordManager: "",
                    passwordManagerConfirm: ""
                }
            };
            if ($scope.ad.managerMode && !$scope.ad.loggedUser.hasManagerPassword)
                $scope.dd.mode = "register";
            else if (!$scope.ad.managerMode)
                $scope.dd.mode = "login";

            $scope.dialog = dialog;
            $scope.cancel = function () {
                dialog.close(false);
            };

            $scope.updateKiuteProUser = function (managerMode) {
                if ($window['kiuteProUser']) {
                    const newKiuteProUser = {...$window['kiuteProUser'], managerMode: managerMode};
                    $window['kiuteProUser'] = newKiuteProUser;
                }
            }

            $scope.quitManagerMode = function () {
                $scope.updateKiuteProUser(false);
                dialog.close(true);
            }
            $scope.loginManagerMode = function () {
                $scope.dd.alerts = [];
                if ($scope.dd.user.passwordManager == "" && $scope.ad.loggedUser.hasManagerPassword) {
                    $scope.addAlert('error', "Merci de renseigner les champs obligatoires");
                    return;
                }
                if (!$scope.ad.loggedUser.hasManagerPassword) {
                    $scope.updateKiuteProUser(true);
                    dialog.close(true);
                } else {
                    $scope.dd.processing = true;

                    UserSrv.loginManagerMode($scope.ad.loggedUser, $scope.dd.user.passwordManager,
                        function (res) {
                            $scope.dd.processing = false;
                            dialog.close(true);
                            $scope.updateKiuteProUser(true);
                        },
                        function (errorMessage) {
                            $scope.addAlert('error', errorMessage);
                            $scope.dd.processing = false;
                        });
                }
            };

            $scope.registerManagerMode = function () {
                $scope.dd.alerts = [];
                if ($scope.dd.user.password == "") {
                    $scope.addAlert('error', "Merci de renseigner les champs obligatoires");
                    return;
                }
                if ($scope.dd.user.passwordManager != $scope.dd.user.passwordManagerConfirm) {
                    $scope.addAlert('error', "Les mots de passe « Gestionnaire » ne sont pas identiques");
                    return;
                }
                $scope.dd.processing = true;

                UserSrv.registerManagerMode($scope.ad.loggedUser, $scope.dd.user.password, $scope.dd.user.passwordManager,
                    function (res) {
                        $scope.dd.processing = false;
                        $scope.updateKiuteProUser(false);
                        if ($scope.dd.user.passwordManager != null && $scope.dd.user.passwordManager != "") {
                            $scope.ad.loggedUser.hasManagerPassword = true;
                        } else {
                            $scope.ad.loggedUser.hasManagerPassword = false;
                        }
                        dialog.close(true);
                    },
                    function (errorMessage) {
                        $scope.addAlert('error', errorMessage);
                        $scope.dd.processing = false;
                    });
            }


            $scope.addAlert = function (type, msg) {
                $scope.dd.alerts.push({type: type, msg: msg});
            };

            $scope.closeAlert = function (index) {
                $scope.dd.alerts.splice(index, 1);
            };


        }
    ]);





// WEBPACK FOOTER //
// ./js/controllers/pro/ManagerModeCtrl.js